import { render, staticRenderFns } from "./departureList.vue?vue&type=template&id=18b32ada&"
import script from "./departureList.vue?vue&type=script&lang=js&"
export * from "./departureList.vue?vue&type=script&lang=js&"
import style0 from "./departureList.vue?vue&type=style&index=0&id=18b32ada&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports